import React from 'react';
import PieLegal from '../legal/PieLegal.jsx';
import './LFooter.css';

function LFooter() {
  return (
    <footer className="lp-footer">
      <div className="lp-container">
        {/* --- 🩹 CIRUGÍA: Añadimos un 'div' que será el recuadro --- */}
        <div className="footer-card">
          <p>&copy; 2026 Non Stop Learning. Todos los derechos reservados.</p>
          <p className="footer-subtitle">
            Hecho con 💛 para estudiantes de ingles en Latinoamerica
          </p>
          {/* La leyenda legal (LEGAL.md, L5): los tres documentos y el correo. */}
          <PieLegal />
        </div>
        {/* --- 🩹 FIN DE CIRUGÍA --- */}
      </div>
    </footer>
  );
}

export default LFooter;